/** Print Wade's signature once per page load, including during hot reloads. */
export function showWadeSignature() {
  if (typeof window === "undefined") return;

  const key = Symbol.for("wade.console.signature");
  if (window[key]) return;

  const art = [
    "██╗    ██╗ █████╗ ██████╗ ███████╗",
    "██║    ██║██╔══██╗██╔══██╗██╔════╝",
    "██║ █╗ ██║███████║██║  ██║█████╗  ",
    "██║███╗██║██╔══██║██║  ██║██╔══╝  ",
    "╚███╔███╔╝██║  ██║██████╔╝███████╗",
    " ╚══╝╚══╝ ╚═╝  ╚═╝╚═════╝ ╚══════╝",
  ];

  const gradient = [
    "#67e8f9",
    "#60a5fa",
    "#818cf8",
    "#a78bfa",
    "#c084fc",
    "#f0abfc",
  ];

  const width = 56;
  const frame = "#526077";

  const center = (text = "") => {
    const left = Math.floor((width - text.length) / 2);
    return (
      " ".repeat(left) +
      text +
      " ".repeat(width - text.length - left)
    );
  };

  const rows = [
    ["╭" + "─".repeat(width) + "╮", frame],
    ["│" + center() + "│", frame],
    ...art.map((text, i) => [
      "│" + center(text) + "│",
      gradient[i],
    ]),
    ["│" + center() + "│", frame],
    ["│" + center("Wade — the one.") + "│", "#f8fafc"],
    ["│" + center() + "│", frame],
    ["│" + center("Not just built. Signed.") + "│", "#94a3b8"],
    ["│" + center() + "│", frame],
    ["╰" + "─".repeat(width) + "╯", frame],
  ];

  const base = [
    "background-color: #090b12",
    "font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
    "font-size: 12px",
    "font-weight: 400",
    "line-height: 1.2",
    "white-space: pre",
  ].join(";");

  // One console entry. No clearing or interfering with application logs.
  console.log(
    rows.map(([text]) => `%c${text}`).join("\n"),
    ...rows.map(([, color]) => `${base};color:${color}`),
  );

  window[key] = true;
}
